const PRINTABLE_ORDER_STATUS_ID = 4;

function isPrintableOrderStatus(value) {
	const numeric = Number(value);
	return !Number.isNaN(numeric) && numeric === PRINTABLE_ORDER_STATUS_ID;
}

export function isCollegeOrderAccepted(request) {
	if (!request) {
		return false;
	}

	const statuses = [
		request.status,
		request.status_id,
		...(request.request_qualifications || []).flatMap((item) => [
			item.status,
			item.status_id,
		]),
	];

	return statuses.some((status) => isPrintableOrderStatus(status));
}

function escapeHtml(value) {
	if (value === null || value === undefined) {
		return '';
	}

	return String(value)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

function renderQualificationSection(slot, t) {
	const title = `${t('Код и наименование')} ${slot.index} ${t('специальности и организации ТиППО')}:`;

	return `
		<div class="print-qualification">
			<div class="print-section-title">${escapeHtml(title)}</div>
			<div class="print-row">
				<span class="print-label">${escapeHtml(t('Специальность'))}:</span>
				<span class="print-value">${escapeHtml(slot.specialty)}</span>
			</div>
			<div class="print-row">
				<span class="print-label">${escapeHtml(t('Квалификация'))}:</span>
				<span class="print-value">${escapeHtml(slot.qualification)}</span>
			</div>
			<div class="print-row">
				<span class="print-label">${escapeHtml(t('Язык обучения'))}:</span>
				<span class="print-value">${escapeHtml(slot.lang)}</span>
			</div>
			<div class="print-row">
				<span class="print-label">${escapeHtml(t('ТиППО'))}:</span>
				<span class="print-value">${escapeHtml(slot.college)}</span>
			</div>
		</div>
	`;
}

export function formatCollegeOrderPrintDateTime(date = new Date()) {
	return new Intl.DateTimeFormat('ru-RU', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	}).format(date);
}

export function buildCollegeOrderPrintHtml({
	t,
	printedAt,
	fullName,
	iin,
	contactPhone,
	educationType,
	hasAdmissionQuota,
	qualifications = [],
	submittedViaLabel,
}) {
	const qualificationSections = qualifications
		.map((slot) => renderQualificationSection(slot, t))
		.join('');

	const yesLabel = t('Да').toUpperCase();
	const noLabel = t('Нет').toUpperCase();
	const submittedVia = submittedViaLabel || t('Подано через ИС Абитуриент EDUS');

	return `<!DOCTYPE html>
<html lang="ru">
<head>
	<meta charset="utf-8" />
	<title>${escapeHtml(t('Форма электронного заявления'))}</title>
	<style>
		@page {
			size: A4 portrait;
			margin: 8mm;
		}

		* {
			box-sizing: border-box;
		}

		body {
			margin: 0;
			padding: 0;
			color: #000;
			font: 10.5px/1.2 Arial, sans-serif;
		}

		.print-page {
			width: 100%;
			max-width: 190mm;
			margin: 0 auto;
			position: relative;
		}

		.print-datetime {
			font-size: 10px;
			line-height: 1.2;
			margin-bottom: 8px;
		}

		.print-title {
			margin: 0 0 8px;
			text-align: center;
			font-size: 13px;
			font-weight: 700;
		}

		.print-row {
			margin: 0 0 3px;
		}

		.print-section-title {
			margin: 5px 0 2px;
			font-weight: 700;
		}

		.print-qualification {
			margin-bottom: 4px;
		}

		.print-label {
			font-weight: 700;
		}

		.print-value {
			font-weight: 400;
		}

		.print-footer-row {
			margin-top: 4px;
		}
	</style>
</head>
<body>
	<div class="print-page">
		<div class="print-datetime">${escapeHtml(printedAt)}</div>
		<h1 class="print-title">${escapeHtml(t('Форма электронного заявления'))}</h1>

		<div class="print-row">
			<span class="print-label">${escapeHtml(t('Фамилия, имя, отчество поступающего'))}:</span>
			<span class="print-value"> ${escapeHtml(fullName)}</span>
		</div>
		<div class="print-row">
			<span class="print-label">${escapeHtml(t('ИИН'))}:</span>
			<span class="print-value"> ${escapeHtml(iin)}</span>
		</div>
		<div class="print-row">
			<span class="print-label">${escapeHtml(t('Контактный телефон (с указанием номера мамы, если абитуриент - ребенок)'))}:</span>
			<span class="print-value"> ${escapeHtml(contactPhone)}</span>
		</div>

		${qualificationSections}

		<div class="print-row print-footer-row">
			<span class="print-label">${escapeHtml(t('Базовое образование'))}:</span>
			<span class="print-value"> ${escapeHtml(educationType)}</span>
		</div>
		<div class="print-row">
			<span class="print-label">${escapeHtml(t('Предусматривается квота приема'))}:</span>
			<span class="print-value"> ${escapeHtml(hasAdmissionQuota ? yesLabel : noLabel)}</span>
		</div>
		<div class="print-row">
			<span class="print-label">${escapeHtml(t('С Единой инструкцией по проведению Конкурса ознакомлен(-а)'))}:</span>
			<span class="print-value"> ${escapeHtml(yesLabel)}</span>
		</div>
		<div class="print-row">
			<span class="print-label">${escapeHtml(t('Даю согласие на сбор, обработку персональных данных'))}:</span>
			<span class="print-value"> ${escapeHtml(yesLabel)}</span>
		</div>
		<div class="print-row print-footer-row">
			<span class="print-value">${escapeHtml(submittedVia)}</span>
		</div>
	</div>
</body>
</html>`;
}

export function openCollegeOrderPrint(html) {
	let iframe = document.getElementById('college-order-print-frame');

	if (iframe) {
		iframe.remove();
	}

	iframe = document.createElement('iframe');
	iframe.id = 'college-order-print-frame';
	iframe.setAttribute('title', 'print');
	Object.assign(iframe.style, {
		position: 'fixed',
		top: '0',
		left: '0',
		width: '0',
		height: '0',
		border: '0',
		opacity: '0',
		pointerEvents: 'none',
	});

	document.body.appendChild(iframe);

	const frameWindow = iframe.contentWindow;
	const frameDocument = frameWindow.document;

	frameDocument.open();
	frameDocument.write(html);
	frameDocument.close();

	const cleanup = () => {
		if (iframe && iframe.parentNode) {
			iframe.parentNode.removeChild(iframe);
		}
	};

	const triggerPrint = () => {
		frameWindow.focus();
		frameWindow.print();
	};

	frameWindow.addEventListener('afterprint', cleanup, { once: true });

	window.setTimeout(() => {
		triggerPrint();
		window.setTimeout(cleanup, 60000);
	}, 250);

	return true;
}

export function formatCollegeOrderPrintQualification(item, index, translateStudyLang) {
	const qualification = item.qualification || {};
	const specialtyCode = qualification.specialty_code || '';
	const specialtyName = qualification.specialty_name || '';
	const qualificationCode = qualification.qualification_code || '';
	const qualificationName = qualification.name || '';

	return {
		index,
		specialty: specialtyCode && specialtyName
			? `${specialtyCode} – ${specialtyName}`
			: (specialtyName || specialtyCode || '—'),
		qualification: qualificationCode && qualificationName
			? `${qualificationCode} – ${qualificationName}`
			: (qualificationName || qualificationCode || '—'),
		lang: translateStudyLang(item.study_lang) || '—',
		college: item.college || '—',
	};
}

export function hasCollegeOrderAdmissionQuota(request, t) {
	const quotaType = request?.documents?.quota_type;

	if (quotaType === null || quotaType === undefined || quotaType === '') {
		return false;
	}

	const normalized = String(quotaType).trim().toLowerCase();
	const withoutQuotaLabel = String(t('Без льготы')).trim().toLowerCase();

	return normalized !== '' && normalized !== withoutQuotaLabel && normalized !== 'нет';
}

export function formatCollegeOrderPrintContactPhone(request) {
	const phone = request?.abiturient?.abiturient_phone || '—';
	const parentPhone = request?.abiturient?.parent_phone;
	const isChildApplicant = Number(request?.abiturient?.declarant) === 2;

	if (isChildApplicant && parentPhone) {
		return `${phone} (${parentPhone})`;
	}

	return phone;
}
